import gandara1 from '../../images/foto-divisi/dokumentasi-divisi/Gandara/foto1.jpeg';
import gandara2 from '../../images/foto-divisi/dokumentasi-divisi/Gandara/foto2.jpeg';
import gandara3 from '../../images/foto-divisi/dokumentasi-divisi/Gandara/foto3.jpeg';
import gandara4 from '../../images/foto-divisi/dokumentasi-divisi/Gandara/foto4.jpeg';
import gandara5 from '../../images/foto-divisi/dokumentasi-divisi/Gandara/foto5.jpeg';
import gandara6 from '../../images/foto-divisi/dokumentasi-divisi/Gandara/foto6.jpeg';
import gandara7 from '../../images/foto-divisi/dokumentasi-divisi/Gandara/foto7.jpeg';
import gandara8 from '../../images/foto-divisi/dokumentasi-divisi/Gandara/foto8.jpeg';
import balwana1 from '../../images/foto-divisi/dokumentasi-divisi/Balwana/foto1.jpeg';
import balwana2 from '../../images/foto-divisi/divisi/Balwana/QHEDY_FOTO TERBAIK_SIMUILASI 2.JPG'
import balwana3 from '../../images/foto-divisi/dokumentasi-divisi/Balwana/foto3.jpeg';
import balwana4 from '../../images/foto-divisi/dokumentasi-divisi/Balwana/foto4.jpeg';
import balwana5 from '../../images/foto-divisi/dokumentasi-divisi/Balwana/foto5.jpeg';
import balwana6 from '../../images/foto-divisi/dokumentasi-divisi/Balwana/foto6.jpeg';
import balwana7 from '../../images/foto-divisi/divisi/Balwana/Perkembangan Hari 2_Diana Angyulia-14.jpg';
import balwana8 from '../../images/foto-divisi/dokumentasi-divisi/Balwana/foto8.jpeg';
import caksana1 from '../../images/foto-divisi/dokumentasi-divisi/Caksana/foto1.jpeg';
import caksana2 from '../../images/foto-divisi/dokumentasi-divisi/Caksana/foto2.jpeg';
import caksana3 from '../../images/foto-divisi/dokumentasi-divisi/Caksana/foto3.jpeg';
import caksana4 from '../../images/foto-divisi/divisi/Caksana/Qhedy_Rapat Pleno 2 (21).jpg';
import caksana5 from '../../images/foto-divisi/dokumentasi-divisi/Caksana/foto5.jpeg';
import caksana6 from '../../images/foto-divisi/dokumentasi-divisi/Caksana/foto6.jpeg';
import caksana7 from '../../images/foto-divisi/dokumentasi-divisi/Caksana/foto7.jpeg';
import caksana8 from '../../images/foto-divisi/divisi/Caksana/Simulasi 2_Baskara_Rether_22.jpg';
import lavanya1 from '../../images/foto-divisi/dokumentasi-divisi/Lavanya/foto1.jpeg';
import lavanya2 from '../../images/foto-divisi/dokumentasi-divisi/Lavanya/foto2.jpeg';
import lavanya3 from '../../images/foto-divisi/dokumentasi-divisi/Lavanya/foto3.jpeg';
import lavanya4 from '../../images/foto-divisi/dokumentasi-divisi/Lavanya/foto4.jpeg';
import lavanya5 from '../../images/foto-divisi/divisi/Lavanya/Simulasi 3_Valentino_59.jpg';
import lavanya6 from '../../images/foto-divisi/dokumentasi-divisi/Lavanya/foto6.jpeg';
import lavanya7 from '../../images/foto-divisi/divisi/Lavanya/Simulasi 2_Andrew Su_Foto Terbaik-21.jpg';
import lavanya8 from '../../images/foto-divisi/dokumentasi-divisi/Lavanya/foto8.jpeg';
import bimasena1 from '../../images/foto-divisi/dokumentasi-divisi/Bimasena/foto1.jpeg';
import bimasena2 from '../../images/foto-divisi/dokumentasi-divisi/Bimasena/foto2.jpeg';
import bimasena3 from '../../images/foto-divisi/dokumentasi-divisi/Bimasena/foto3.jpeg';
import bimasena4 from '../../images/foto-divisi/dokumentasi-divisi/Bimasena/foto4.jpeg';
import bimasena5 from '../../images/foto-divisi/dokumentasi-divisi/Bimasena/foto5.jpeg';
import bimasena6 from '../../images/foto-divisi/dokumentasi-divisi/Bimasena/foto6.jpeg';
import bimasena7 from '../../images/foto-divisi/divisi/Bimasena/Perkembangan Hari 1_Oxa_Foto Terbaik-19.jpg';
import bimasena8 from '../../images/foto-divisi/dokumentasi-divisi/Bimasena/foto8.jpeg';
import baskara1 from '../../images/foto-divisi/dokumentasi-divisi/Baskara/foto1.jpeg';
import baskara2 from '../../images/foto-divisi/dokumentasi-divisi/Baskara/foto2.jpeg';
import baskara3 from '../../images/foto-divisi/dokumentasi-divisi/Baskara/foto3.jpeg';
import baskara4 from '../../images/foto-divisi/dokumentasi-divisi/Baskara/foto4.jpeg';
import baskara5 from '../../images/foto-divisi/dokumentasi-divisi/Baskara/foto5.jpeg';
import baskara6 from '../../images/foto-divisi/dokumentasi-divisi/Baskara/foto6.jpeg';
import baskara7 from '../../images/foto-divisi/dokumentasi-divisi/Baskara/foto7.jpeg';
import baskara8 from '../../images/foto-divisi/divisi/Baskara/IMG_2736.jpg';
import gajendra1 from '../../images/foto-divisi/divisi/Gajendra/Pengecatan Papan Gajendra_Andrew Su-2.jpg';
import gajendra2 from '../../images/foto-divisi/dokumentasi-divisi/Gajendra/foto2.jpeg';
import gajendra3 from '../../images/foto-divisi/dokumentasi-divisi/Gajendra/foto3.jpeg';
import gajendra4 from '../../images/foto-divisi/dokumentasi-divisi/Gajendra/foto4.jpeg';
import gajendra5 from '../../images/foto-divisi/dokumentasi-divisi/Gajendra/foto5.jpeg';
import gajendra6 from '../../images/foto-divisi/dokumentasi-divisi/Gajendra/foto6.jpeg';
import gajendra7 from '../../images/foto-divisi/dokumentasi-divisi/Gajendra/foto7.jpeg';
import gajendra8 from '../../images/foto-divisi/dokumentasi-divisi/Gajendra/foto8.jpeg';
import sakha1 from '../../images/foto-divisi/dokumentasi-divisi/Sakha/foto1.jpeg';
import sakha2 from '../../images/foto-divisi/dokumentasi-divisi/Sakha/foto2.jpeg';
import sakha3 from '../../images/foto-divisi/dokumentasi-divisi/Sakha/foto3.jpeg';
import sakha4 from '../../images/foto-divisi/dokumentasi-divisi/Sakha/foto4.jpeg';
import sakha5 from '../../images/foto-divisi/dokumentasi-divisi/Sakha/foto5.jpeg';
import sakha6 from '../../images/foto-divisi/dokumentasi-divisi/Sakha/foto6.jpeg';
import sakha7 from '../../images/foto-divisi/dokumentasi-divisi/Sakha/foto7.jpeg';
import sakha8 from '../../images/foto-divisi/dokumentasi-divisi/Sakha/foto8.jpeg';
import nayanika1 from '../../images/foto-divisi/dokumentasi-divisi/Nayanika/foto1.jpeg';
import nayanika2 from '../../images/foto-divisi/dokumentasi-divisi/Nayanika/foto2.jpeg';
import nayanika3 from '../../images/foto-divisi/dokumentasi-divisi/Nayanika/foto3.jpeg';
import nayanika4 from '../../images/foto-divisi/dokumentasi-divisi/Nayanika/foto4.jpeg';
import nayanika5 from '../../images/foto-divisi/dokumentasi-divisi/Nayanika/foto5.jpeg';
import nayanika6 from '../../images/foto-divisi/divisi/Nayanika/Simulasi 2_Allison_Foto Terbaik_11.JPG';
import nayanika7 from '../../images/foto-divisi/dokumentasi-divisi/Nayanika/foto7.jpeg';
import nayanika8 from '../../images/foto-divisi/dokumentasi-divisi/Nayanika/foto8.jpeg';
import sarkara1 from '../../images/foto-divisi/dokumentasi-divisi/Sarkara/foto1.jpeg';
import sarkara2 from '../../images/foto-divisi/dokumentasi-divisi/Sarkara/foto2.jpeg';
import sarkara3 from '../../images/foto-divisi/divisi/Sarkara/Simulasi 2_BASKARA_Maria Cahaya_PERS-3.jpg'
import sarkara4 from '../../images/foto-divisi/dokumentasi-divisi/Sarkara/foto4.jpeg';
import sarkara5 from '../../images/foto-divisi/dokumentasi-divisi/Sarkara/foto5.jpeg';
import sarkara6 from '../../images/foto-divisi/dokumentasi-divisi/Sarkara/foto6.jpeg';
import sarkara7 from '../../images/foto-divisi/dokumentasi-divisi/Sarkara/foto7.jpeg';
import sarkara8 from '../../images/foto-divisi/divisi/Sarkara/Perkembangan Hari 2_Rether_41.jpg';
import saraya1 from '../../images/foto-divisi/divisi/Saraya/Perkembangan Hari 1_Andrew Su-40.jpg';
import saraya2 from '../../images/foto-divisi/dokumentasi-divisi/Saraya/foto2.jpeg';
import saraya3 from '../../images/foto-divisi/dokumentasi-divisi/Saraya/foto3.jpeg';
import saraya4 from '../../images/foto-divisi/dokumentasi-divisi/Saraya/foto4.jpeg';
import saraya5 from '../../images/foto-divisi/dokumentasi-divisi/Saraya/foto5.jpeg';
import saraya6 from '../../images/foto-divisi/dokumentasi-divisi/Saraya/foto6.jpeg';
import saraya7 from '../../images/foto-divisi/dokumentasi-divisi/Saraya/foto7.jpeg';
import saraya8 from '../../images/foto-divisi/dokumentasi-divisi/Saraya/foto8.jpeg';


const sectionFotoData ={
    "FOTO":[
        {
            foto1: gandara1,
            foto2: gandara2,
            foto3: gandara3,
            foto4: gandara4,
            foto5: gandara5,
            foto6: gandara6,
            foto7: gandara7,
            foto8: gandara8,
        },
        {
            foto1: balwana1,
            foto2: balwana2,
            foto3: balwana3,
            foto4: balwana4,
            foto5: balwana5,
            foto6: balwana6,
            foto7: balwana7,
            foto8: balwana8,
        },
        {
            foto1: caksana1,
            foto2: caksana2,
            foto3: caksana3,
            foto4: caksana4,
            foto5: caksana5,
            foto6: caksana6,
            foto7: caksana7,
            foto8: caksana8,
        },
        {
            foto1: lavanya1,
            foto2: lavanya2,
            foto3: lavanya3,
            foto4: lavanya4,
            foto5: lavanya5,
            foto6: lavanya6,
            foto7: lavanya7,
            foto8: lavanya8,
        },
        {
            foto1: bimasena1,
            foto2: bimasena2,
            foto3: bimasena3,
            foto4: bimasena4,
            foto5: bimasena5,
            foto6: bimasena6,
            foto7: bimasena7,
            foto8: bimasena8,
        },
        {
            foto1: baskara1,
            foto2: baskara2,
            foto3: baskara3,
            foto4: baskara4,
            foto5: baskara5,
            foto6: baskara6,
            foto7: baskara7,
            foto8: baskara8,
        },
        {
            foto1: gajendra1,
            foto2: gajendra2,
            foto3: gajendra3,
            foto4: gajendra4,
            foto5: gajendra5,
            foto6: gajendra6,
            foto7: gajendra7,
            foto8: gajendra8,
        },
        {
            foto1: sakha1,
            foto2: sakha2,
            foto3: sakha3,
            foto4: sakha4,
            foto5: sakha5,
            foto6: sakha6,
            foto7: sakha7,
            foto8: sakha8,
        },
        {
            foto1: nayanika1,
            foto2: nayanika2,
            foto3: nayanika3,
            foto4: nayanika4,
            foto5: nayanika5,
            foto6: nayanika6,
            foto7: nayanika7,
            foto8: nayanika8,
        },
        {
            foto1: sarkara1,
            foto2: sarkara2,
            foto3: sarkara3,
            foto4: sarkara4,
            foto5: sarkara5,
            foto6: sarkara6,
            foto7: sarkara7,
            foto8: sarkara8,
        },
        {
            foto1: saraya1,
            foto2: saraya2,
            foto3: saraya3,
            foto4: saraya4,
            foto5: saraya5,
            foto6: saraya6,
            foto7: saraya7,
            foto8: saraya8,
        },
    ]
}

export default sectionFotoData;